import { Badge, Card, Title } from "@common";

export default function CardInfo({ title, items, className = "" }) {
  return (
    <Card className={className}>
      <div className="p-6">
        <Title level={2} className="mb-4">
          {title}
        </Title>

        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <span className="text-sm text-smiles-gray">{item.label}</span>
              {item.badge ? (
                <Badge color={item.badgeColorKey} className={item.badgeColor}>
                  {item.value}
                </Badge>
              ) : (
                <span className="text-sm text-smiles-darkGray">{item.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
